import { AuthContainer, AuthFormContainer, AuthFormBg } from 'pages/auth/style'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useGetSfUserByIdQuery } from 'store/api-slices/userSlice'
import { RootState, useAppDispatch, useAppSelector } from 'store/store'
import { FormTypes } from 'types/enums/EFormTypes'
import {
  PersonalAreaBackround,
  PersonalAreaBody,
  PersonalAreaSubTitle,
  PersonalAreaTitle,
  TabContentContainer,
} from './style'
import { PersonalAreaTabs } from './components/personalAreaTabs/PersonalAreaTabs'
import { updateUser } from 'store/reducers/userReducer'
import { EPersonalAreaTabs } from 'types/enums/EPersonalAreaTabs'
import { usePersonalTabsData } from 'shared/hooks/usePersonalTabsData'
import HamburgerMenu from 'shared/components/hamburger-menu/HamburgerMenu'

export const PersonalArea: React.FC = () => {
  const direction = useSelector(
    (state: RootState) => state.layout.language.direction,
  )
  const isLoading = useSelector((state: RootState) => state.layout.isLoading)
  const dispatch = useAppDispatch()
  const user = useAppSelector((state) => state.user)
  const personalDetails = useAppSelector((state) => state.user).personalDetails

  const getSfUser = useGetSfUserByIdQuery()
  const { data, error, isFetching, isError } = getSfUser
  const [tabTtile, setTabTitle] = useState(EPersonalAreaTabs.LOBBY.toString())
  const tabs = usePersonalTabsData()

  useEffect(() => {
    if (!isFetching && !isError) {
      if (data?.personalDetails) {
        dispatch(updateUser({ ...user, personalDetails: data.personalDetails }))
      }
    } else if (isError) {
      console.log('[UserDetails] error getSfUser: ', error)
    }
  }, [data])

  return (
    <AuthContainer
      formType={FormTypes.PERSONAL_AREA_PAGE}
      formStep={null}
      direction={direction}
    >
      <HamburgerMenu />
      <AuthFormContainer
        formType={FormTypes.PERSONAL_AREA_PAGE}
        direction={direction}
      >
        <AuthFormBg
          isLoading={isLoading}
          formType={FormTypes.PERSONAL_AREA_PAGE}
        >
          <PersonalAreaBackround>
            <PersonalAreaTitle>
              <h2>
                {personalDetails?.firstName}&nbsp;
                {personalDetails?.lastName}
              </h2>
              <PersonalAreaSubTitle>
                <p>{data?.email}</p>
                <p> {'|'} </p>
                <p>{data?.personalDetails?.id}</p>
              </PersonalAreaSubTitle>
            </PersonalAreaTitle>
            <PersonalAreaBody>
              <PersonalAreaTabs setTabTitle={setTabTitle}></PersonalAreaTabs>
              <TabContentContainer>
                {tabs.find((tab) => tab.title.key === tabTtile)?.content}
              </TabContentContainer>
            </PersonalAreaBody>
          </PersonalAreaBackround>
        </AuthFormBg>
      </AuthFormContainer>
    </AuthContainer>
  )
}
